import { UserProfileRole } from 'ts-interfaces';
import { USERPILOT_TOKEN } from './firebase.js';
import { Userpilot } from 'userpilot';

let initialized = false;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleCreatedAt(createdAt: any) {
  /**
   * Handles createdAt timestamp formatting for Userpilot
   * - Userpilot expects a string, not a Firebase object
   * - createdAt seems to have been in various formats
   * - duplicated in bulk_identify.cjs
   * @param createdAt - Firebase timestamp, number, or null
   * @returns ISO string date or null
   */

  if (!createdAt) {
    return '';
  }

  if (typeof createdAt.toDate === 'function') {
    return createdAt.toDate().toISOString();
  }

  if (typeof createdAt === 'number') {
    return new Date(createdAt).toISOString();
  }

  if (typeof createdAt === 'object' && typeof createdAt.seconds === 'number') {
    // Convert seconds to milliseconds
    return new Date(createdAt.seconds * 1000).toISOString();
  }

  return '';
}

export function initAnalytics() {
  // only init once
  if (initialized) return;
  Userpilot.initialize(USERPILOT_TOKEN);
  initialized = true;
}

function handleName(profile) {
  const firstName = profile?.first_name || '';
  const lastName = profile?.last_name || '';
  if (firstName && lastName) {
    return firstName + ' ' + lastName;
  }
  if (firstName) {
    return firstName;
  }
  if (lastName) {
  return firstName || lastName;
  }
  return '';
}

export function identifyUser({currentUser, profile}) {
  if (!initialized) return;
  
  // Return early if currentUser is completely missing
  if (!currentUser || !currentUser.uid) {
    console.warn('identifyUser: currentUser or currentUser.uid is missing');
    return;
  }

  // Determine email: prefer currentUser.email, fallback to profile.email
  const email = currentUser.email || profile?.email;
  
  if (!email) {
    console.warn('identifyUser: No email available in currentUser or profile');
    return;
  }

  const metadata = {
    name: handleName(profile),
    email: email,
    company: profile?.company_name || '',
    companySize: profile?.company_size || '',
    country: profile?.country || '',
    industry: profile?.industry || '',
    occupation: profile?.occupation || '',
    specialization: profile?.specialization || '',
    userRole: profile?.role || '',   
    created_at: handleCreatedAt(profile?.created_at),
  }
  try {
    Userpilot.identify(currentUser.uid, metadata);
  } catch (error) {
    console.error('identifyUser', error);
  }
}

export interface AnyProperties {
  [key: string]: string | number | boolean | null | undefined;
}

export function trackEvent(event: string, properties?: AnyProperties) {
  if (initialized) {
    Userpilot.track(event, properties);
  }
}

export function disableAnalytics() {
  // Clear Analytics instance manually
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).userpilot = undefined;
  initialized = false;
}
